<div class="wrapper mb-5">
    <div class="row align-items-center m-0" style="padding: 10px;">
        <img class="p-2" src="./assets/icons/arrow.svg">
        <span class="label-title ml-2 mr-3">Saldo detalhado</span>
    </div>
    <div class="component-box container-fluid">
        <div class="container-fluid pt-4">
            <div class="row">
                <div class="col-md-6 col-sm-12">
                    <ul class="options-cadastro pl-0 float-left">
                        <li>
                            <div (click)="exportExtractExcel()" class="list-select ml-2 my-1">
                                <button _ngcontent-khv-c20="" class="list-select"  type="button">
                                    <span>Exportar Excel</span>
                                </button>
                            </div>
                        </li>
                        <li>
                            <div (click)="exportExtractPdf()" class="list-select ml-2 my-1">
                                <button _ngcontent-khv-c20="" class="list-select"  type="button">
                                    <span>Exportar PDF</span>
                                </button>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="col-md-6 col-sm-12 text-right">
                    <ul class="options-cadastro">
                        <li>
                            <div *ngIf="filtroOn" (click)="deleteFilter()" class="list-select ml-2
                                my-1">
                                <button class="list-select-delete" type="button">
                                    Apagar filtro
                                </button>
                            </div>
                        </li>
                        <li>
                            <div (click)="showFilter(filtroModal)" class="list-select ml-2 my-1">
                                <button class="list-select"  type="button">
                                    <span><img src="assets/icons/filter.svg" style="height: 15px;"> Aplicar filtro</span>
                                    <!-- <span *ngIf="filtroOn"><img src="assets/icons/filter-purple.svg" style="height: 15px;"> Alterar filtro</span> -->
                                </button>
                            </div>
                        </li>
                        <li>
                            <div class="list-filter-show-item ml-2 my-1">
                                Mostrar:
                                <select (change)="showItemChanged($event.target.value)" class="ng-untouched ng-pristine ng-valid">
                                    <option _ selected="" value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            
            <span  class="d-flex justify-content-end clean-modal-text my-2" style="font-size:small;">Data da consulta: {{ queryDate | date: "dd/MM/yy HH:mm:ss" }}</span>

            <div class="row">
                <div class="col-12" *ngIf="filtroOn">
                    <ul class="options-cadastro pl-0 float-left" #filterText>
                        <li *ngIf="filtro.collaboratorsId?.length > 0" class="mr-3"><b>Favorecidos: </b>{{ collaboratorsFilterText }}</li>
                        <li *ngIf="filtro.productsId?.length > 0" class="mr-3"><b>Produtos: </b>{{ productsFilterText }}</li>
                    </ul>
                </div>
            </div>            
            <div class="table-overflow">
                <div class="table-responsive visible-table">
                    <table class="list-table table table-striped" id="dataTable" width="100%" cellspacing="0">
                        <thead>
                            <th>CPF</th>
                            <th>Favorecido</th>
                            <th>Produto</th>
                            <th>Valor</th>
                        </thead>
                        <tbody class="list-table-row">
                            <tr *ngFor=" let item of favorecidos | paginate : { itemsPerPage: showItem, currentPage: currentPage, totalItems: totalItems, id: 'detailedBalance'  }">
                                <td>{{ item.document | cpf }}</td>
                                <td>{{ item.collaborator }}</td>
                                <td>{{ item.product }}</td>
                                <td>
                                    <span>R$</span><span style="float: right; clear: both">{{ item.value | currency: '' }}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    
                    <div *ngIf="!favorecidos || favorecidos == [] || favorecidos.length == 0" class="text-center">
                            Nenhum saldo carregado. Aplique o filtro para retornar a lista de saldos
                    </div>

                    <div class="page-custom mt-2">
                        <pagination-controls id="detailedBalance" (pageChange)="carregarRelatorio($event)" responsive="true" previousLabel="" nextLabel=""></pagination-controls>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--Modal do Filtro-->
<ng-template #filtroModal let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Aplicar filtro</h5>
        </div>
    </div>
    <div class="row col-12 clean-modal-content">
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field>
                    <mat-select [formControl]="collaboratorsServerSideCtrl" [multiple]="true" placeholder="Favorecidos" [value]="colla">
                        <!-- place ngx-mat-select-search inside mat-option to allow opening without initial selection -->
                        <mat-option>
                            <ngx-mat-select-search
                            [formControl]="collaboratorsServerSideFilteringCtrl"
                            [searching]="searching"
                            placeholderLabel="Procure um favorecido"
                            noEntriesFoundLabel="Nenhum favorecido encontrado"></ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let item of collaboratorsFiltered | async" [value]="item">
                            {{item.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>   
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field>
                    <mat-select [formControl]="productsCtrl" id="produto" [multiple]="true" placeholder="Produtos" [value]="filtro.productsId">
                        <mat-option *ngFor="let item of productList" [value]="item.produtoId">
                            {{item.descricaoProduto}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>    
    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button custom-filter-button-just" type="button" (click)="applyFilter();modal.dismiss('Close click')" ngbAutofocus>
            Aplicar
        </button>
    </div>
</ng-template>